import { render, staticRenderFns } from "./SignificantEventList.vue?vue&type=template&id=9df5ad20&scoped=true&"
import script from "./SignificantEventList.vue?vue&type=script&lang=js&"
export * from "./SignificantEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df5ad20",
  null
  
)

export default component.exports